import * as React from 'react'
import * as service from '../../services'
import { useDispatch } from 'react-redux'
import { Box } from '@mui/material'
import { features as setFeature } from '../../redux/slices/Tree/treeFeatures'
import {
  setSelectedList,
  setFilterState,
  setFiltersUsed,
  setSearchByType,
  setTypeSearchUsed,
  setEnabledFilter,
} from '../../redux/slices/Search/input'
import { infoOptions } from '../../utils'
import AutoCompleteItem from '../Autocomplete'

const MSJ = 'No se encuentraron registros, intente nuevamente o recarge la página.'

const SearchMain = ({ searchType, filterList1, width }) => {
  const dispatch = useDispatch()
  const [options, setOptions] = React.useState(null)
  const placeholder = infoOptions?.[searchType]?.name

  const handleSelection = (e, newList) => dispatch(setSelectedList(newList))
  const handleDeleteALL = async (event, value, reason) => {
    if (reason === 'clear') {
      const geojson = await service.getAllDataByTreesFilters(searchType, [])
      if (!Object.keys(geojson).length) window.alert(MSJ)
      else {
        dispatch(setFeature(geojson))
        dispatch(setFilterState(true))
        dispatch(setFiltersUsed([]))
        dispatch(setSearchByType(''))
        dispatch(setTypeSearchUsed(''))
        dispatch(setEnabledFilter(false))
      }
    }
  }

  React.useEffect(() => {
    if (!Boolean(searchType)) return
    infoOptions?.[searchType]
      ?.func()
      .then(res => setOptions(res))
      .catch(err => console.log('Error :>> ', err))
    return () => setOptions(null)
  }, [searchType])

  if (!searchType || !options) return null

  return (
    <Box sx={{ width }}>
      <AutoCompleteItem
        multiple
        type={searchType}
        valueList={filterList1}
        onChange={handleSelection}
        options={options}
        onInputChange={handleDeleteALL}
        placeholder={placeholder}
      />
    </Box>
  )
}
export default SearchMain
